// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__2kk8y","copyright":"Footer_copyright__37D72"};